import { filter } from 'lodash'

export const namespaced = true

const getDefaultState = () => {
  return {
    step: 'create',
    errors: [],
    stepHide: 'true'
  }
}

export const state = getDefaultState()

export const mutations = {
  CHANGE_STEP(state, step) {
    state.step = step
  },
  SET_STEP_HIDE(state, stepHide) {
    state.stepHide = stepHide
  },
  SET_VALUE(state, parameters) {
    state[parameters.type] = parameters.value
  },
  ADD_ERROR(state, error) {
    state.errors.push(error)
  },
  SET_ERRORS(state, errors) {
    state.errors = errors
  }
}

export const getters = {
  step: state => {
    return state.step
  },
  stepHide: state => {
    return state.stepHide
  }
}

export const actions = {
  addError({ commit, state }, error) {
    const errorExists = filter(state.errors, item => {
      return item.type === error.type
    })

    if (errorExists.length === 0) {
      commit('ADD_ERROR', error)
    }
  },
  removeError({ commit, state }, errorType) {
    commit(
      'SET_ERRORS',
      filter(state.errors, error => {
        return error.type !== errorType
      })
    )
  },
  changeStep({ commit }, step) {
    commit('CHANGE_STEP', step)
  },
  changeStepHide({ commit }, stepHide) {
    commit('SET_STEP_HIDE', stepHide)
  },
  setValue({ commit }, parameters) {
    commit('SET_VALUE', parameters)
  }
}
